import React, { Component } from "react";
import * as PropTypes from "prop-types";
import FileDropzone from "../FileDropzone";
import FileUploadApi from "../../api/gen/qsign/FileUploadApi";
import { Alert, Button, Card, CardBody, CardHeader } from "reactstrap";
import { ActionsRow, commons } from "@mc/mc-legacy";
import Dropzone from "react-dropzone";
import classNames from "classnames";
import { toastr } from "../../utils/mc-toastr";
import "./FileUploadField.scss";
const { sinkEvent } = commons;
/**
 * Field pro upload souborů
 */

export default class FileUploadField extends Component {
  static defaultProps = {
    multiple: false,
    max: 10,
  };
  static propTypes = {
    multiple: PropTypes.bool,
    max: PropTypes.number,
  };
  state = {
    placeholders: [],
    origFiles: [],
  };
  setLoading = (name) => {
    this.setState((state) => ({
      placeholders: [
        ...state.placeholders,
        {
          loading: true,
          loaded: false,
          name: name,
        },
      ],
    }));
  };
  setLoaded = (name) => {
    const newPlaceholders = [
      ...this.state.placeholders.filter((i) => {
        return i.name !== name;
      }),
    ];
    this.setState({
      placeholders: newPlaceholders,
    });
  };

  findInFiles(name) {
    const {
      input: { value },
    } = this.props;
    const { placeholders } = this.state;
    return value.find((v) => v.name === name) || placeholders.find((v) => v.name === name);
  }

  handleAddFile = (files, rejectedFiles) => {
    rejectedFiles.forEach((file) => {
      toastr.error("Soubor " + file.name + " není ve formátu PDF");
    });
    let count = this.props.input.value.length; // exists files

    for (let i = 0; i < files.length; i++) {
      if (this.props.max <= count) {
        toastr.warning("Byl dovršen maximální počet souborů (" + this.props.max + ").");
        break;
      }

      const file = files[i];

      if (this.findInFiles(file.name)) {
        toastr.warning("Soubor " + file.name + " je již zařazen pro zpracování.");
        continue;
      }

      count++;
      this.setLoading(file.name);
      FileUploadApi.uploadDocument(file, file.name).then((tempDoc) => {
        this.props.input.onChange([...this.props.input.value, tempDoc]);
        this.setLoaded(tempDoc.name);
      });
    }
  };
  handleDeleteFile = (file, index) => {
    FileUploadApi.deleteDocuments([file.uuid]).then(() => {
      const files = this.props.input.value;
      const newFiles = files.filter((v) => {
        return v.uuid !== file.uuid;
      });
      this.props.input.onChange([...newFiles]);
    });
  };

  handleSetAttachment = (isPriloha, index) => {
    const files = this.props.input.value;
    const newFiles = {...files}
    newFiles[index].attachment = isPriloha;
    this.props.input.onChange([...files]);
  };
  isDragMode = () => {
    const {
      input: { value },
    } = this.props;
    const { placeholders } = this.state;
    const length = value.length + placeholders.length;

    if (length) {
      return length === 0;
    } else {
      return true;
    }
  };
  actions = () => {
    const { readOnly, multiple } = this.props;
    return (
      <div>
          <Dropzone
            //accept={"application/pdf"}
            disabled={readOnly}
            multiple={multiple}
            className={"actions-fileupload"}
            onDrop={this.handleAddFile}
          >
            {({ getRootProps, getInputProps }) => {
              return (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />

                  <Button color={"primary"} onClick={(e) => sinkEvent(e)} label={"Vyberte soubory z disku"}>
                    Vyberte soubory na disku
                  </Button>
                </div>
              );
            }}
          </Dropzone>
      </div>
    );
  };

  render() {
    const {
      onChage,
      onBlur,
      input: { value },
      meta: { error, submitFailed, valid },
      ...otherProps
    } = this.props;
    const { placeholders } = this.state;
    const isDragMode = this.isDragMode();
    const files = [...placeholders, ...value];
    const cls = classNames(
      {
        "file-dropzone-field-wrapper": isDragMode,
      },
      "flex-column",
      "no-x-padding"
    );
    return (
      <Card className={"file-upload-field"}>
        <CardHeader>
          <ActionsRow actions={this.actions()}>
            <h2>Nahrané soubory</h2>
          </ActionsRow>
        </CardHeader>
        <CardBody className={cls}>
          <FileDropzone
            {...otherProps}
            files={files}
            onAddFile={this.handleAddFile}
            onDeleteFile={this.handleDeleteFile}
            setAttachment={this.handleSetAttachment}
            isDragMode={isDragMode}
            /* accept={"application/pdf"} */
          />
        </CardBody>
        {submitFailed && !valid && <Alert color="danger">{error}</Alert>}
      </Card>
    );
  }
}
